import { render } from "./uploader.vue?vue&type=template&id=7ba9b78c"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/khatanbaatarb/Documents/projects/roadpay.mn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__